export default [
  {
    path: '/examList',
    name: 'ExamList',
    component: () => import('@/views/exam/examList/index.vue'),
    meta: { title: 'app_my_examination', zhTitle: '我的考试', pageLevel: 2 }
  },
  {
    path: '/examPreflight',
    name: 'ExamPreflight',
    component: () => import('@/views/exam/preflight/index.vue'),
    meta: { title: 'app_exam_info', zhTitle: '考试中转', pageLevel: 3 }
  },
  {
    path: '/examInfo',
    name: 'ExamInfo',
    component: () => import('@/views/exam/info/index.vue'),
    meta: { title: 'app_exam_info', zhTitle: '考试信息', customWechatShare: true, pageLevel: 3 }
  },
  {
    path: '/paper',
    name: 'Paper',
    component: () => import('@/views/exam/paper/index.vue'),
    meta: { title: 'app_exam_paper', zhTitle: '考试答题' }
  },
  {
    path: '/commit',
    name: 'Commit',
    component: () => import('@/views/exam/commit/index.vue'),
    meta: { title: 'app_submit', zhTitle: '提交', pageLevel: 3 }
  },
  {
    path: '/result',
    name: 'Result',
    component: () => import('@/views/exam/result/index.vue'),
    meta: { title: 'app_paper_detail', zhTitle: '答题详情' }
  },
  {
    path: '/empty',
    name: 'Empty',
    component: () => import('@/components/EmptyPage.vue'),
    meta: { title: '' }
  },
  {
    path: '/examPractiseInfo',
    name: 'ExamPractiseInfo',
    component: () => import('@/views/exam/examPractise/examPractiseInfo.vue'),
    meta: { title: 'pc_practice_detail', zhTitle: 'pc_practice_detail', customWechatShare: true, pageLevel: 3 }
  },
  {
    path: '/examPractisePaper',
    name: 'ExamPractisePaper',
    component: () => import('@/views/exam/examPractise/examPractisePaper.vue'),
    meta: { title: 'app_practice_answer_questions', zhTitle: 'app_practice_answer_questions' }
  }
]
